import React from 'react';

export function Spacer({ x, y }: { x?: React.CSSProperties['width']; y?: React.CSSProperties['height'] }) {
  return <div style={{ width: x, height: y }} />;
}
